(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = s => root.querySelector(s), qa = s => Array.from(root.querySelectorAll(s));
    const image = q('[data-ip-main-image]'), thumbs = q('[data-ip-thumbs]'), quantity = q('[data-ip-quantity]'), add = q('[data-ip-add]');
    let size = root.dataset.initialVariant, view = 'render';
    const selected = () => ({dataset:{price:root.dataset.price,stock:root.dataset.stock}});
    const price = () => Number(selected().dataset.price);
    const variant = () => size;
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(n / 100);
    function sanitizeQuantity() { quantity.value = Math.min(99, Math.max(1, Math.trunc(Number(quantity.value) || 1))); }
    function selectView(next) {
      const button = thumbs.querySelector('[data-ip-view="' + next + '"]');
      if (!button) return;
      view = next;
      q('.ip-image-stage').dataset.ipActiveView = view;
      image.src = button.querySelector('img').src;
      image.alt = button.getAttribute('aria-label');
      image.width = Number(button.dataset.width || 1420);
      image.height = Number(button.dataset.height || 1108);
      thumbs.querySelectorAll('[data-ip-view]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }
    function chooseSize(next, updateURL = true) {
      if (!q('[data-ip-gallery="' + next + '"]')) return;
      size = next;
      thumbs.replaceChildren(q('[data-ip-gallery="' + size + '"]').content.cloneNode(true));
      selectView('render');
      q('[data-ip-price]').textContent = money(price());
      q('[data-ip-variant]').value = variant();
      const allowed = root.dataset.purchase === 'true' && selected().dataset.stock === 'true';
      add.disabled = !allowed;
      add.firstChild.textContent = (root.dataset.purchase === 'true' && !allowed ? root.dataset.soldOut : root.dataset.atc) + ' ';
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant()); history.replaceState(history.state, '', url); }
    }
    thumbs.addEventListener('click', e => { const b = e.target.closest('[data-ip-view]'); if (b && thumbs.contains(b)) selectView(b.dataset.ipView); });
    q('[data-ip-facts-link]').addEventListener('click', () => { selectView('facts'); q('.ip-image-stage').scrollIntoView({ block: 'center', behavior: 'auto' }); });
    qa('[data-ip-quantity-change]').forEach(b => b.addEventListener('click', () => { sanitizeQuantity(); quantity.value = Number(quantity.value) + Number(b.dataset.ipQuantityChange); sanitizeQuantity(); }));
    quantity.addEventListener('change', sanitizeQuantity);
    q('.ip-product-form').addEventListener('submit', e => { sanitizeQuantity(); if (add.disabled || root.dataset.purchase !== 'true') e.preventDefault(); });
    const initial = new URL(location.href).searchParams.get('variant');
    chooseSize(q('[data-ip-gallery="' + initial + '"]') ? initial : root.dataset.initialVariant, false);
    const guide = q('#ip-research'), guideTrigger = q('#ip-research-toggle');
    let lastGuideFocus;
    function openGuide(event) { if (event) { event.preventDefault(); event.stopPropagation(); } lastGuideFocus = document.activeElement; guideTrigger.setAttribute('aria-expanded', 'true'); if (!guide.open) guide.showModal(); guide.scrollTop = 0; }
    guideTrigger.addEventListener('click', openGuide);
    qa('[data-ip-open-guide]').forEach(b => b.addEventListener('click', openGuide));
    q('#ip-research-close').addEventListener('click', () => guide.close());
    guide.addEventListener('close', () => { guideTrigger.setAttribute('aria-expanded', 'false'); lastGuideFocus?.focus({ preventScroll: true }); });
    function outsideCloses(dialog) { dialog.addEventListener('click', e => { if (e.target !== dialog) return; const b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close(); }); }
    outsideCloses(guide);
    qa('.ip-benefit-deep-link').forEach(a => a.addEventListener('click', e => { e.preventDefault(); q('#ip-deep').scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }));
    const imageDialog = q('[data-ip-image-dialog]'), dialogImage = q('[data-ip-image-dialog-image]'), zoom = q('[data-ip-image-zoom]');
    let lastImageFocus;
    q('[data-ip-zoom-open]').addEventListener('click', () => { lastImageFocus = document.activeElement; imageDialog.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed', 'false'); zoom.textContent = root.dataset.zoom; dialogImage.src = image.src; dialogImage.alt = image.alt; dialogImage.width = image.width; dialogImage.height = image.height; q('[data-ip-image-title]').textContent = image.alt; imageDialog.showModal(); });
    q('[data-ip-image-close]').addEventListener('click', () => imageDialog.close());
    zoom.addEventListener('click', () => { const expanded = imageDialog.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(expanded)); zoom.textContent = expanded ? root.dataset.fit : root.dataset.zoom; });
    imageDialog.addEventListener('close', () => { imageDialog.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed', 'false'); zoom.textContent = root.dataset.zoom; lastImageFocus?.focus({ preventScroll: true }); });
    outsideCloses(imageDialog);
    let reviews = [], total = 0, shown = 3, liveApplied = false;
    const clean = x => new DOMParser().parseFromString(String(x || ''), 'text/html').body.textContent || '';
    function text(tag, value, cls) { const n = document.createElement(tag); n.textContent = value; if (cls) n.className = cls; return n; }
    function photosFor(review) { return review.images_data || review.imagesData || []; }
    function renderReviews() {
      const sorted = [...reviews].sort((a, b) => {
        const mode = q('[data-ip-review-sort]').value;
        if (mode === 'highest') return Number(b.score) - Number(a.score);
        if (mode === 'lowest') return Number(a.score) - Number(b.score);
        const date = String(b.created_at || b.createdAt).localeCompare(String(a.created_at || a.createdAt));
        return mode === 'oldest' ? -date : date;
      });
      const list = q('[data-ip-review-list]'); list.replaceChildren();
      sorted.slice(0, shown).forEach(r => {
        const article = document.createElement('article'); article.className = 'ip-review';
        const author = text('div', r.user?.display_name || r.user?.displayName || '', 'ip-review-author');
        const badges = [];
        if (r.verified_buyer || r.verifiedBuyer) badges.push(root.dataset.verified);
        if ([true, 1, 'true', '1'].includes(r.is_incentivized) || [true, 1, 'true', '1'].includes(r.isIncentivized)) badges.push(root.dataset.incentivized);
        author.append(text('div', badges.join(' · '), 'ip-review-meta'));
        const rawDate = r.created_at || r.createdAt;
        const date = rawDate ? new Date(rawDate) : null;
        if (date && !Number.isNaN(date.getTime())) {
          const stamp = text('time', new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date), 'ip-review-date');
          stamp.dateTime = date.toISOString(); author.append(stamp);
        }
        const content = document.createElement('div'), stars = text('div', '★'.repeat(Math.min(5, Math.max(0, Math.round(r.score)))), 'ip-stars');
        stars.setAttribute('aria-label', r.score + ' / 5'); content.append(stars, text('h3', clean(r.title)), text('p', clean(r.content)));
        article.append(author, content); list.append(article);
      });
      q('[data-ip-review-more]').hidden = shown >= reviews.length;
    }
    function applyReviews(data) {
      const payload = data.response || data;
      const allReviews = (payload.reviews || []).filter(r => !r.deleted);
      reviews = allReviews;
      const average = allReviews.length ? allReviews.reduce((sum, r) => sum + Number(r.score || 0), 0) / allReviews.length : 0;
      total = allReviews.length;
      q('[data-ip-top-rating]').textContent = average.toFixed(1) + ' · ' + total + ' ' + root.dataset.reviewWord;
      q('[data-ip-review-average]').textContent = total ? average.toFixed(1) : '—';
      q('.ip-rating').hidden = total === 0;
      q('[data-ip-review-total]').textContent = root.dataset.allReviews.replace('__COUNT__', String(total));
      const gallery = q('[data-ip-review-photos]'); gallery.replaceChildren();
      reviews.forEach(r => photosFor(r).forEach(photo => {
        const src = photo.original_url || photo.originalUrl || photo.image_url || photo.imageUrl || photo.thumb_url || photo.thumbUrl;
        if (!src || !/^https:\/\//.test(src)) return;
        const a = document.createElement('a'); a.href = src; a.target = '_blank'; a.rel = 'noopener noreferrer';
        const img = document.createElement('img'); img.src = photo.thumb_url || photo.thumbUrl || src; img.alt = clean(r.title); img.loading = 'lazy'; img.width = 160; img.height = 160; a.append(img);
        const figure = document.createElement('figure'); figure.className = 'ip-review-photo';
        const caption = document.createElement('figcaption'); caption.append(text('span', r.user?.display_name || r.user?.displayName || ''));
        if ([true, 1, 'true', '1'].includes(r.is_incentivized) || [true, 1, 'true', '1'].includes(r.isIncentivized)) caption.append(text('small', root.dataset.incentivized));
        figure.append(a, caption); gallery.append(figure);
      }));
      q('[data-ip-review-photo-section]').hidden = !gallery.childNodes.length;
      renderReviews();
    }
    q('[data-ip-review-more]').addEventListener('click', () => { shown += 3; renderReviews(); });
    q('[data-ip-review-sort]').addEventListener('change', renderReviews);
    fetch(root.dataset.reviewsUrl, { credentials: 'same-origin' }).then(r => { if (!r.ok) throw Error('reviews'); return r.json(); }).then(data => { if (!liveApplied) applyReviews(data); }).catch(() => {});
    async function loadLiveReviews() {
      const records = [], ids = new Set();
      let page = 1, expected = Infinity;
      while (records.length < expected) {
        const url = new URL(root.dataset.liveReviews); url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'omit' });
        if (!response.ok) throw Error('reviews');
        const data = await response.json(), payload = data.response || data, next = payload.reviews || [];
        const unique = next.filter(r => !ids.has(r.id));
        if (!unique.length) { if (records.length < expected) throw Error('incomplete reviews'); break; }
        unique.forEach(r => { ids.add(r.id); records.push(r); });
        expected = Number(payload.pagination?.total || payload.bottomline?.total_review || payload.bottomline?.totalReview || records.length);
        page += 1;
      }
      liveApplied = true;
      applyReviews({ reviews: records });
    }
    loadLiveReviews().catch(() => {});
  }
  const boot = scope => scope.querySelectorAll('[data-ip-genesis]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();









